import React from "react";
import Logo from "../../assets/logo.png";
import PageFooterBusiness from "../../components/PageFooterBusiness";

const Refund = () => (
  <div>
    <div className="flex flex-col items-start justify-start px-8 py-7 w-full ">
      <div
        className="flex flex-row "
        role="button"
        tabIndex={0}
        onClick={() => window.open("https://monthler.kr", "_blank")}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            window.open("https://monthler.kr", "_blank");
          }
        }}
        style={{ cursor: "pointer" }}
      >
        <img className="w-9" src={Logo} alt="한달살러 로고" />
        <p className="font-black text-[20px] ml-1 mt-2">한달살러</p>
      </div>
      <h1 className="font-bold mt-10 mb-2 text-lg">한달살러 참가비 환불 규정</h1>
      <h2 className="font-bold mt-10 mb-2 ">1. 주요 용어 정의</h2>
      <p className="text-sm leading-7 text-gray-700 ">
        참가 시작일: 사용자가 신청서 작성 시 직접 선택한 참가 일정의 시작일을 의미합니다.
        <br />
        (예: 4/2 ~ 4/5 일정 신청 시, 참가 시작일은 4/2)
        <br />
        결제일: 참가자가 한달살러 플랫폼에서 참가비를 결제한 날짜를 의미합니다.
        <br />
        환불 가능 기간: 참가 시작일 이전까지 환불 요청이 가능한 기간을 의미합니다.
      </p>
      <h2 className="font-bold mt-10 mb-2 ">2. 환불 요청 가능 조건</h2>
      <p className="text-sm leading-7 text-gray-700 ">
        2.1 환불 요청은 이메일(nomadc.monthler@gmail.com)로만 접수됩니다.
        <br />
        2.2 결제 후 24시간 이내(단, 참가 시작 전날 18:00 이후 결제한 경우 제외)에는 전액 환불이
        가능합니다. <br />
        2.3 참가 시작 전날 18:00 이후 결제한 경우에는 환불이 불가능합니다. <br />
        2.4 참가 시작일 당일(00:00 이후)에는 어떠한 사유로도 환불이 불가능합니다. <br />
        2.5 회사의 귀책사유(예: 프로그램 취소, 운영상의 문제 등)로 인해 참가가 불가능할 경우, 전액
        환불됩니다. <br />
        2.6 소비자 보호법에 따라, 결제 후 7일 이내이며 참가 시작일이 남아있는 경우에는 환불이
        가능합니다.
      </p>
      <h2 className="font-bold mt-10 mb-2 ">3. 환불 절차</h2>
      <p className="text-sm leading-7 text-gray-700 ">
        3.1 환불 요청은 반드시 이메일(nomadc.monthler@gmail.com)로 접수해야 합니다.
        <br />
        3.2 환불 요청 승인 후, 환불 금액은 영업일 기준 10일 이내 처리됩니다.
        <br />
        3.3 결제 수단에 따라 환불 소요 시간이 다를 수 있으며, 결제 대행사의 정책에 따릅니다.
      </p>
      <h2 className="font-bold mt-10 mb-2 ">4. 환불 금액 산정 기준 (수수료 공제 포함)</h2>
      <p className="text-sm leading-7 text-gray-700 ">
        4.1 결제 후 24시간 이내(단, 참가 시작 전날 18:00 이후 결제한 경우 제외)에는 전액 환불 가능{" "}
        <br />
        4.2 결제 후 24시간이 경과했거나, 참가 시작일까지 7일 미만 남은 경우 → 결제 금액의 80% 환불
        (운영비 20% 공제) <br />
        4.3 참가 시작 전날 18:00까지 환불 요청 시 → 결제 금액의 50% 환불 (운영비 및 준비 비용 50%
        공제) <br />
        4.4 참가 시작일 당일(00:00 이후)에는 환불이 절대 불가합니다. <br />
        4.5 예외적으로 환불이 승인된 경우, 결제 금액의 50%만 환불 가능하며, 위약금(50%)이
        공제됩니다. <br />
        4.6 법적으로 청약철회가 불가능한 경우(디지털 콘텐츠, 서비스 제공 개시 후 등)는 환불이
        불가능합니다. <br />
      </p>
      <h2 className="font-bold mt-10 mb-2 ">5. 환불 불가 사유 (명확한 고지)</h2>
      <p className="text-sm leading-7 text-gray-700 ">
        5.1 참가 시작일 이후(예: 4/2일 00:00 이후)에는 어떠한 사유로도 환불이 불가합니다. <br />
        5.2 모집 마감 후(참가 시작 전날 18:00 이후) 결제한 경우에도 참가 시작일 이후 환불이
        불가합니다. <br />
        5.3 개인적인 사유(단순 변심, 일정 변경, 건강 문제, 긴급 상황 등)로 인한 환불 요청은
        불가능합니다.
        <br />
        5.4 프로그램 내용이 기대와 다르다는 이유로 환불 요청하는 경우 환불이 불가합니다. <br />
        5.5 신청 과정에서 환불 규정을 충분히 숙지하지 않은 상태에서 결제한 경우에도 환불이
        불가합니다. <br />
        5.6 프로그램 진행 중 사용자의 귀책사유(규정 위반, 부적절한 행동 등)로 참여가 제한된 경우에도
        환불이 불가합니다. <br />
        5.7 프로그램이 온라인으로 진행되거나 디지털 콘텐츠가 포함된 경우, 서비스 제공이 시작된
        이후에는 법적으로 환불이 불가할 수 있습니다.
      </p>
      <div className="h-20" />
      <PageFooterBusiness partnerName="" />
    </div>
  </div>
);

export default Refund;
